import { makeUrl } from 'utils';
// prettier-ignore
export const ENDPOINTS = {
  AUTH:              makeUrl(process.env.REACT_APP_AUTH_URL, process.env.REACT_APP_AUTH_PATH, '/auth'),
  GET_APP_DATA:      makeUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_GET_APP_DATA_PATH,'/api'),
  CHECK_CARD_NUMBER: makeUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_CHECK_CARD_NUMBER_PATH,'/api'),
  GET_COMMISSION:    makeUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_GET_COMMISSION_PATH,'/api'),
  VALIDATE_MERCHANT: makeUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_VALIDATE_MERCHANT_PATH,'/api'),
  CREATE:            makeUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_CREATE_PATH, '/api'),
  CONFIRM:           makeUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_CONFIRM_PATH, '/api'),
  CONFIRM_3DS:       makeUrl(process.env.REACT_APP_API_URL, process.env.REACT_APP_CONFIRM_3DS_PATH)
};
